import { Box, Typography, useMediaQuery } from "@mui/material";
import { pendingRequestsTableStyles } from "../../styles/styles";
import JobsTypeDropdown from "./JobsTypeDropdown";
import MyJobsCard from "../MyJobsCard";
import { useTranslation } from "react-i18next";

// Item-type tabs for the Active Jobs & Orders section. Products, Services and
// Restaurants are live; Coupons is upcoming (shown disabled with a "Soon" tag).
const ITEM_TABS = [
  { value: "product", labelKey: "item_type_products", enabled: true },
  { value: "service", labelKey: "item_type_services", enabled: true },
  { value: "restaurant", labelKey: "item_type_restaurants", enabled: true },
  { value: "coupon", labelKey: "item_type_coupons", enabled: true },
];

const JobsTable = (props) => {
  const {
    containerRef,
    activeTab,
    isLoading,
    data,
    jobsType,
    setJobsType,
    itemType,
    setItemType,
    onJobUpdated,
    handleViewButtonClick,
    hasMore,
    loadMore,
  } = props;

  const isMobile = useMediaQuery("(max-width:767px)");
  const showMobileItemTabs = activeTab !== "pending";
  const { t } = useTranslation("page-my-jobs");
  const { containerStyles, titleBoxStyles, titleText } =
    pendingRequestsTableStyles;

  return (
    <Box sx={{ ...containerStyles, paddingBottom: "16px", maxHeight: isMobile ? "none" : containerStyles.maxHeight }}>
      {!isMobile && (
        <Typography sx={{ ...titleText, mb: "8px" }}>
          {t("active_jobs_orders")}
        </Typography>
      )}

      <Box
        sx={{
          ...titleBoxStyles,
          // On mobile the page-level tabs pick the status, so only the
          // item-type tabs show here — and not on New Jobs, which is mixed-type.
          display: !isMobile || showMobileItemTabs ? "flex" : "none",
          ...(isMobile && { paddingBottom: "12px" }),
        }}
      >
        {/* Item-type tabs */}
        <Box
          sx={{
            display: "flex",
            gap: isMobile ? "20px" : "24px",
            alignItems: "center",
            ...(isMobile && {
              overflowX: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }),
          }}
        >
          {ITEM_TABS.map((tab) => {
            const active = itemType === tab.value;
            return (
              <Box
                key={tab.value}
                onClick={() => tab.enabled && setItemType?.(tab.value)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: tab.enabled ? "pointer" : "default",
                  paddingBottom: "6px",
                  borderBottom: active
                    ? "2px solid rgba(28, 160, 138, 1)"
                    : "2px solid transparent",
                  opacity: tab.enabled ? 1 : 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: active ? 600 : 500,
                    color: active
                      ? "rgba(28, 160, 138, 1)"
                      : "rgba(62, 63, 76, 0.9)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t(tab.labelKey)}
                </Typography>
                {!tab.enabled && (
                  <Box
                    sx={{
                      fontSize: "10px",
                      fontWeight: 600,
                      color: "rgba(255, 151, 51, 1)",
                      backgroundColor: "rgba(255, 151, 51, 0.16)",
                      borderRadius: "8px",
                      padding: "1px 6px",
                    }}
                  >
                    {t("soon")}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>

        {!isMobile && <JobsTypeDropdown {...{ jobsType, setJobsType }} />}
      </Box>

      <MyJobsCard
        {...{
          containerRef,
          jobsType: isMobile ? activeTab : jobsType,
          data,
          isLoading,
          itemType: isMobile && !showMobileItemTabs ? "service" : itemType,
          onJobUpdated,
          handleViewButtonClick,
          hasMore,
          loadMore,
        }}
      />
    </Box>
  );
};

export default JobsTable;
